import * as React from 'react'

import { TableColumn } from '../../../client/clientjs/components/Table/types'
import withTranslator from '../../../client/clientjs/components/TranslatorProvider'
import { TranslatorProviderInjectedProps } from '../../../client/clientjs/components/types'

const Table = require('../../../client/clientjs/components/Table')

interface StatElement {
  value: string
  count?: number
  usersWhoGotFishCount?: number
  averageFishPerUser?: number
  min_score?: number
  average_score?: number
  max_score?: number
  min_size?: number
  average_size?: number
  max_size?: number
  min_weight?: number
  average_weight?: number
  max_weight?: number
}

interface State {
  stats: StatElement[]
  columns: TableColumn<StatElement>[]
}

interface OwnProps {
  stats: StatElement[]
}

type Props = OwnProps & TranslatorProviderInjectedProps

class ContestStatsTable extends React.PureComponent<Props, State> {
  public constructor(props: Props) {
    super(props)

    const { stats, translate } = props

    const columns: TableColumn<StatElement>[] = [
      {
        name: 'value',
        display: translate('contestStats.speciesName'),
        getCellValue: row => row.value,
        isSortable: true,
        isBold: true,
        isTextCentered: true,
      },
      {
        name: 'count',
        display: translate('contestStats.count'),
        getCellValue: row => row.count || 0,
        isSortable: true,
        isBold: true,
        isTextCentered: true,
        getCellRawValue: row => {
          // we pad because the filter will use a string filter ! so with padding zeros we compare the right thing
          return `${`${(row.count || 0) * 1000}`.padStart(15, '0')}`
        },
      },
      {
        name: 'anglers',
        display: translate('contestStats.anglersCount'),
        getCellValue: row => row.usersWhoGotFishCount || 0,
        isSortable: true,
        isBold: false,
        isTextCentered: true,
        getCellRawValue: row => `${Math.round((row.usersWhoGotFishCount || 0) * 100)}`.padStart(15, '0'),
      },
      {
        name: 'anglersAvg',
        display: translate('contestStats.averageFishPerAngler'),
        getCellValue: row => row.averageFishPerUser || '--',
        isSortable: true,
        isBold: false,
        isTextCentered: true,
        getCellRawValue: row => `${Math.round((row.averageFishPerUser || 0) * 100)}`.padStart(15, '0'),
      },
    ]
    if (stats.some(elt => (elt.min_score || 0) > 0 || (elt.average_score || 0) > 0 || (elt.max_score || 0) > 0)) {
      columns.push({
        name: 'score',
        display: translate('contestStats.scoreMinAvgMax'),
        getCellValue: row =>
          (row.min_score || 0) > 0 || (row.average_score || 0) > 0 || (row.max_score || 0) > 0
            ? [row.min_score || '--', row.average_score || '--', row.max_score || '--'].join(' / ')
            : '',
        isSortable: false,
        isBold: false,
        isTextCentered: true,
      })
    }
    if (stats.some(elt => (elt.min_size || 0) > 0 || (elt.max_size || 0) > 0 || (elt.average_size || 0) > 0)) {
      columns.push({
        name: 'size',
        display: translate('contestStats.sizeMinAvgMax'),
        getCellValue: row =>
          (row.min_size || 0) > 0 || (row.max_size || 0) > 0 || (row.average_size || 0) > 0
            ? [row.min_size || '--', row.average_size || '--', row.max_size || '--'].join(' / ')
            : '',
        isSortable: false,
        isBold: false,
        isTextCentered: true,
      })
    }
    if (stats.some(elt => (elt.min_weight || 0) > 0 || (elt.max_weight || 0) > 0 || (elt.average_weight || 0) > 0)) {
      columns.push({
        name: 'weight',
        display: translate('contestStats.weightMinAvgMax'),
        getCellValue: row =>
          (row.min_weight || 0) > 0 || (row.max_weight || 0) > 0 || (row.average_weight || 0) > 0
            ? [row.min_weight || '--', row.average_weight || '--', row.max_weight || '--'].join(' / ')
            : '',
        isSortable: false,
        isBold: false,
        isTextCentered: true,
      })
    }

    this.state = {
      stats,
      columns,
    }
  }

  public render() {
    const { stats, columns } = this.state
    return (
      <Table
        columns={columns}
        rows={stats}
        defaultSortBy="count"
        defaultSortASC={false}
        getRowKey={(row: StatElement) => row.value}
        tableClass="is-size-7 is-size-8-mobile is-self-centered"
      />
    )
  }
}

export default withTranslator(ContestStatsTable)
